import Swiper from 'swiper/bundle'

export default function EmployeeSlider () {
  const WRAPPERS = document.querySelectorAll('.mtt-employee-slider')

  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]
      const SWIPER_CONTAINER = WRAPPER.querySelector('.swiper-container')
      const PREV_BUTTON = WRAPPER.querySelector('.swiper-button-prev')
      const NEXT_BUTTON = WRAPPER.querySelector('.swiper-button-next')

      const SWIPER = new Swiper(SWIPER_CONTAINER, {
        init: false,
        slidesPerView: 1.1,
        speed: 800,
        spaceBetween: 24,
        watchOverflow: true,
        navigation: {
          nextEl: NEXT_BUTTON,
          prevEl: PREV_BUTTON
        },
        breakpoints: {
          501: { slidesPerView: 1.5 },
          651: { slidesPerView: 2 },
          801: { slidesPerView: 2.5 },
          1001: { slidesPerView: 3 }
        }
      })

      SWIPER.init()

      // Add hover effects
      if (SWIPER.slides.length > 0) {
        for (let i = 0; i < SWIPER.slides.length; i++) {
          const SLIDE = SWIPER.slides[i]
          const EMPLOYEE_COMPANIES = SLIDE.getAttribute('data-employee-companies')

          if (EMPLOYEE_COMPANIES) {
            const IDS = EMPLOYEE_COMPANIES.split(', ')

            if (IDS.length > 0) {

              const LOGOS = []
              for (let j = 0; j < IDS.length; j++) {
                const ID = IDS[j]
                const LOGO = document.querySelector(`.mtt-employee-slider__logo[data-id="${ID}"]`)
                if (LOGO) LOGOS.push(LOGO)
              }

              SLIDE.addEventListener('mouseenter', () => {
                for (let j = 0; j < LOGOS.length; j++) {
                  LOGOS[j].classList.add('active')
                }
              })
              SLIDE.addEventListener('mouseleave', () => {
                for (let j = 0; j < LOGOS.length; j++) {
                  LOGOS[j].classList.remove('active')
                }
              })
            }
          }
        }
      }
    }
  }
}
